export const MENU_ACTIVE_USERS = 1
export const MENU_ACTIVE_BUSINESS = 2
export const TORNOS = 1;
export const SALAS = 2;
export const GYM = 3;